import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useState } from 'react';

import { SavedFilterResults } from '@/zod_schemas';

const VariantSelectionDropdown = () => {
  const { getValues } = useFormContext<SavedFilterResults>();

  const [, setVariantSelection] = useState(
    getValues().request_filters?.variant_selection ?? 0,
  );

  const [pendingSelection, setPendingSelection] = useState<number | null>(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [ignoreConfirm, setIgnoreConfirm] = useState(false);

  const handleConfirm = () => {
    if (pendingSelection !== null) {
      setVariantSelection(pendingSelection);
    }
    setConfirmOpen(false);
  };

  const handleCancel = () => {
    setPendingSelection(null);
    setConfirmOpen(false);
  };

  return (
    <Dialog open={confirmOpen} onClose={handleCancel}>
      <DialogTitle>Confirm Variant Filter Change</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={1}>
          <div>Are you sure you want to change the variant filter?</div>
          <FormControlLabel
            control={
              <Checkbox
                checked={ignoreConfirm}
                onChange={(e) => setIgnoreConfirm(e.target.checked)}
              />
            }
            label="Don't ask me again"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VariantSelectionDropdown;
